export const CHANGE_DARK_MODE = 'uiTheme/CHANGE_DARK_MODE';
export const TOGGLE_SIDEBAR = 'uiTheme/TOGGLE_SIDEBAR';
export const TOGGLE_ASIDE = 'uiTheme/TOGGLE_ASIDE';
